import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import CenterCircle from '../../../../../../assets/2025/topic900/CenterCircle.png';
import CodeIcon1 from '../../../../../../assets/2025/topic900/code_icon1.png';
import CodeIcon2 from '../../../../../../assets/2025/topic900/code_icon2.png';
import CodeIcon3 from '../../../../../../assets/2025/topic900/code_icon3.png';
import CodeIcon4 from '../../../../../../assets/2025/topic900/code_icon4.png';
import CodeIcon5 from '../../../../../../assets/2025/topic900/code_icon5.png';
import CodeIcon6 from '../../../../../../assets/2025/topic900/code_icon6.png';
import { WTitle } from '../../components/Widget';
import { useStore } from '../../../../store';
import { useUpdateComponentState } from '../../../hooks';
interface ISection3Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });
  const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  React.useEffect(() => {
    if (state.play >= 6) {
      updateComponentState(p_course, p_topic, ID, '2025-topic900-section3-1');
      // updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [p_course, p_topic, state.play, updateParagraphState]);
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ play: next, isPlayed: true });
    if (next <= 6) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  return (
    <>
      <i className="back_piece" />
      <div className="padding_box">
        <div id="2025-topic900-section3-1" className="topic-section-3">
          <WTitle title={paragraphsSettings?.title} />
          <p
            className="content"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.l3,
            }}
          />
          <div className="base-practice-section" onClick={() => startPlay()}>
            <img
              className={`arrow-point ${state.play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <img className="center-circle" src={CenterCircle} alt="" />
            <div className="bp-panel-1 bp-panel-0">
              <img src={CodeIcon1} alt="" />
              {paragraphsSettings?.l5}
            </div>
            <div
              className={`bp-panel-2 bp-panel-0 ${
                state.play > 1 ? 'fade-in' : ''
              }`}
            >
              <img src={CodeIcon2} alt="" />
              {paragraphsSettings?.l6}
            </div>
            <div
              className={`bp-panel-3 bp-panel-0 ${
                state.play > 2 ? 'fade-in' : ''
              }`}
            >
              <img src={CodeIcon3} alt="" />
              {paragraphsSettings?.l7}
            </div>
            <div
              className={`bp-panel-4 bp-panel-0 ${
                state.play > 3 ? 'fade-in' : ''
              }`}
            >
              <img src={CodeIcon4} alt="" />
              {paragraphsSettings?.l8}
            </div>
            <div
              className={`bp-panel-5 bp-panel-0 ${
                state.play > 4 ? 'fade-in' : ''
              }`}
            >
              <img src={CodeIcon5} alt="" />
              {paragraphsSettings?.l9}
            </div>
            <div
              className={`bp-panel-6 bp-panel-0 ${
                state.play > 5 ? 'fade-in' : ''
              }`}
            >
              <img src={CodeIcon6} alt="" />
              {paragraphsSettings?.l10}
            </div>
          </div>
        </div>
      </div>
      <i className="bottom_bg" />
    </>
  );
};

export default Section3;
